export default {
  username: "",
  password: "",
  confirmPassword: "",
  email: "",
  name: "",
  telephone: "",
  roleIds: [],
  serviceContractsFilter: [],
  customerIds: [],
  partnerId: null,
  ownedByPartnerId: null,
};
